import { render, staticRenderFns } from "./PartnerAccounts.vue?vue&type=template&id=295e7542&scoped=true"
import script from "./PartnerAccounts.vue?vue&type=script&lang=js"
export * from "./PartnerAccounts.vue?vue&type=script&lang=js"
import style0 from "./PartnerAccounts.vue?vue&type=style&index=0&id=295e7542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e7542",
  null
  
)

export default component.exports